import { memo, HTMLAttributes } from "react";
import { StaticImage } from "../StaticImage";
import { useStyles } from "./ServiceSelectionOld.style";

export interface IServiceSelectionItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: { src1x?: string; src2x?: string; src3x?: string };
  onClickScrollTo: () => void;
}

const ServiceSelectionItemComponent: React.FC<
  IServiceSelectionItemProps & HTMLAttributes<HTMLDivElement>
> = ({ icon, onClickScrollTo, ...otherProps }) => {
  const classes = useStyles();

  return (
    <div
      {...otherProps}
      className={classes.rowService}
      onClick={() => onClickScrollTo()}
    >
      <StaticImage
        src={icon.src1x}
        src2x={icon.src2x}
        src3x={icon.src3x}
        alt="service item"
        width={80}
        height={80}
      />
    </div>
  );
};

export const ServiceSelectionItem = memo(ServiceSelectionItemComponent);
